module.exports = __webpack_public_path__ + "img/fakeNationalId-min.719ad8f2.png";